import { AuditLog, AuditField, PagedAuditResponse } from './audit-log.model';

export class ExpenseSkeleton {
  expenseId: number;
  expenseCategoryId: number;
  isDeleted: boolean;
  // todo: documents (can be uploaded but aren't actually attached to expenses yet - come back to this later when they are)
}

export const EMPTY_EXPENSE_SKELETON: ExpenseSkeleton = {
  expenseId: 0,
  expenseCategoryId: 0,
  isDeleted: false
};

export class ExpenseAuditField extends AuditField {}
export class ExpenseAuditLog extends AuditLog {
  auditFields: ExpenseAuditField[];
}
export class PagedExpenseAudit extends PagedAuditResponse {
  resultSet: ExpenseAuditLog[];
}
